import React, { createContext, type FC } from 'react'

export type ToastVariant = 'info' | 'success' | 'warning' | 'error' | 'gray'

export interface ToastContent {
    id?: string
    title: string
    description?: string
    variant?: ToastVariant
    duration?: number // pass Infinity for persistent toast (default: 5000ms)
    showProgressRing?: boolean // Show circular progress ring around X button (default: true, hidden if duration is 0)
    icon?: React.ReactNode | FC<{className: string}> // Custom icon support
    action?: {
        label: string
        onAction: () => void
    }
    secondaryAction?: {
        label: string
        onAction: () => void
    }
    hideDismissButton?: boolean // Option to hide the dismiss button, if a secondary action is provided its automatically hidden
    onClose?: () => void
}

export interface ToastContextValue {
    showToast: (content: ToastContent) => string
    closeToast: (key: string) => void
    closeAllToasts: () => void
}

export const ToastContext = createContext<ToastContextValue | undefined>(undefined)